module.exports = __webpack_public_path__ + "static/media/cms-contact-icon.78cc7281.svg";